<template>
  <v-list-item
    :class="listItemClass"
    :data-test="`picker-list-item-${props.item.title}`"
    dense
    :two-line="!dense"
    :disabled="!props.item.expandable && !props.item.selectable"
    @click.stop="clickRow"
  >
    <v-list-item-action v-if="props.prependIcon && props.item.selectable">
      <slot name="prepend-action" :on="{ click: handleSelect }">
        <v-simple-checkbox
          v-if="checkbox"
          :value="props.isSelected"
          :color="props.checkboxColor"
          @input="handleSelect"
        />
        <v-radio-group v-else :value="props.isSelected ? props.item.id : undefined">
          <v-radio :value="props.item.id" @click="handleSelect" />
        </v-radio-group>
      </slot>
    </v-list-item-action>

    <v-list-item-content>
      <vs-text
        :truncate="truncate"
        :over-flow-wrap="truncate ? 'anywhere' : 'initial'"
        :title="props.item.title"
        >{{ props.item.title }}
      </vs-text>
      <vs-text v-if="props.item.subTitle" truncate type="subdued" :title="props.item.subTitle">
        {{ props.item.subTitle }}
      </vs-text>
    </v-list-item-content>
    <v-list-item-action v-if="props.item.expandable">
      <span class="disclosure">
        {{ props.item.childCount }}
        <v-icon>mdi-chevron-right</v-icon>
      </span>
    </v-list-item-action>
  </v-list-item>
</template>

<script setup lang="ts">
import VsText from '@/components/vision/VsText.vue'
import { PickerItemType } from './models'
import { computed } from 'vue'

interface Props {
  item: PickerItemType
  isSelected?: boolean | null
  checkbox?: boolean | null
  checkboxColor?: string | null
  prependIcon?: boolean | null
  dense?: boolean | null
  truncate?: boolean | null
}

const props = withDefaults(defineProps<Props>(), {
  item: () => ({
    id: null,
    title: '',
    subTitle: null,
    childCount: 0,
    expandable: false,
    selectable: true,
  }),
  isSelected: false,
  checkbox: false,
  prependIcon: true,
  dense: false,
  checkboxColor: null,
  truncate: true,
})

const emit = defineEmits<{
  (event: 'select', value: PickerItemType): void
  (event: 'expand', value: PickerItemType): void
}>()

const handleSelect = () => {
  emit('select', props.item)
}

const clickRow = () => {
  if (props.item.expandable) {
    emit('expand', props.item)
  } else if (props.item.selectable) {
    emit('select', props.item)
  }
}

const listItemClass = computed(() => ({
  'item-selected-background': !props.prependIcon && props.isSelected,
  'item-disabled': !props.item.expandable && !props.item.selectable,
}))
</script>

<style scoped>
.disclosure {
  display: inline-flex;
}

.item-selected-background {
  background-color: var(--color-blue--lighter);
}

.item-disabled {
  opacity: 0.5;
  color: #999;
}
</style>
